<template>
    <div class="getTicket" v-if="show">
        <div class="activityMsg">
            <div class="headImg">
                <img :src="eventinfo.sharelogo" alt="">
            </div>
            <p class="inviter">{{eventinfo.sharename}}邀请您一起参与</p>
            <p class="eventTitle">{{eventinfo.eventname}}</p>
            <div class="eventImg">
                <img :src="eventinfo.eventlogo" alt="">
            </div>
            <div class="time">活动时间：{{eventinfo.eventtime}}</div>
            <div class="address">活动地点：{{eventinfo.eventaddress}}</div>
            <div class="dotted">
                <div class="line"></div>
                <div class="left"></div>
                <div class="right"></div>
            </div>
            <div class="btnBox">
                <van-button type="default" class="get" v-if="eventinfo.isreceive" @click="getTicket">领取票券</van-button>
                <van-button type="default" class="noget" v-else>已被领光</van-button>
            </div>
        </div>
        <p class="checkAty" @click="checkAtyMsg">查看活动详情</p>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {getShareDeatil, saveShareTicketForGet} from 'api/activeTools'
export default {
    name: 'getTicket',
    data() {
        return {
            eventinfo: {},
            eventid: this.$route.query.eventid,
            shareid: this.$route.query.shareid,
            show: false
        }
    },
    mounted() {
        this.getShareDeatil()
        document.title = '领取票券'
    },
    methods: {
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        getShareDeatil() {
            this.setLoading(true)
            getShareDeatil({
                data: {eventid: this.eventid, shareid: this.shareid},
                success: data => {
                    this.setLoading(false)
                    this.show = true
                    this.eventinfo = data.data.deatilinfo
                    document.title = this.eventinfo.eventname
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 领取票券
        getTicket() {
            if (!this.eventinfo.isneeduser) {
                this.setLoading(true)
                saveShareTicketForGet({
                    data: {eventid: this.eventid, shareid: this.shareid, ticketuserid: ''},
                    success: () => {
                        this.setLoading(false)
                        this.$toast.success('领取成功')
                        this.$router.push({name: 'myTicket', query: {eventid: this.eventid}})
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            } else {
                this.$router.push({name: 'AaSginUpAdd', query: {eventid: this.eventid, shareid: this.shareid}})
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
    }
}
</script>
<style lang="scss">
    .getTicket{
        height: 100%;
        padding: 0.96rem 0.32rem 0.4rem;
        background: #F5F7FA;
        box-sizing: border-box;
        .activityMsg{
            padding: 0.4rem 0.32rem;
            background: #fff;
            box-shadow:0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
            .headImg{
                text-align: center;
                width: 100%;
                position: relative;
                display: flex;
                justify-content: center;
                height: 0.7rem;
                img{
                    position: relative;
                    top: -0.96rem;
                    width: 1.28rem;
                    height: 1.28rem;
                    border-radius: 50%;
                }
            }
            .inviter{
                text-align: center;
                color: #999999;
                font-size: 0.28rem;
            }
            .eventTitle{
                padding-top: 0.32rem;
                width: 100%;
                font-size: 0.32rem;
                line-height: 0.45rem;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                font-weight: 550;
            }
            .eventImg{
                padding-top: 0.28rem;
                padding-bottom: 0.4rem;
                img{
                    width: 100%;
                    height: 3.48rem;
                    border-radius: 0.15rem;
                }
            }
            .time,.address{
                font-size: 0.26rem;
                color: #666666;
                margin-bottom: 0.12rem;
                line-height: 0.38rem;
            }
            .address{
                width: 100%;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .dotted{
                padding: 0.3rem 0;
                position: relative;
                .line{
                    border-bottom: 0.02rem dashed #999999;
                }
                .left, .right{
                    width: 0.15rem;
                    height: 0.3rem;
                    background: #F5F7FA;
                    position: absolute;
                    top: 0.15rem;
                }
                .left{
                    left: -0.35rem;
                    border-radius: 0 0.15rem 0.15rem 0;
                }
                .right{
                    right: -0.35rem;
                    border-radius: 0.15rem 0 0 0.15rem;
                }
            }
            .btnBox{
                .van-button{
                    width: 100%;
                    height: 0.76rem;
                    line-height: 0.76rem;
                    font-size: 0.32rem;
                    border-radius: 0.4rem;
                    color: #fff;
                }
                .get{
                    background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
                }
                .noget{
                    background:linear-gradient(180deg,rgba(151,237,205,1) 0%,rgba(133,224,172,1) 100%,rgba(132,223,169,1) 100%);
                }
            }
        }
        .checkAty{
            padding-top: 0.4rem;
            padding-bottom: 0.2rem;
            color: #4995EC;
            text-align: center;
            font-size: 0.26rem;
            background: #F5F7FA;
        }
    }
</style>